import { render, staticRenderFns } from "./FixedPhraseTool.vue?vue&type=template&id=7b589e75&scoped=true&"
import script from "./FixedPhraseTool.vue?vue&type=script&lang=ts&"
export * from "./FixedPhraseTool.vue?vue&type=script&lang=ts&"
import style0 from "./FixedPhraseTool.vue?vue&type=style&index=0&id=7b589e75&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b589e75",
  null
  
)

export default component.exports